/**
 * EAA-1212: query keys for the system-settings domain.
 *
 * The config read is keyed by user AND language: the server localises each key's
 * `label`/`description` from Accept-Language, so the language is ambient scope and
 * belongs in the key (CLAUDE.md "scoped reads carry their scope") — otherwise a
 * language switch keeps serving the other language's copy.
 *
 * The upload limits are platform-wide, so they are keyed by nothing but their name.
 * The storage space belongs to one tenant, so the acting tenant id is in its key.
 */

export const systemSettingsKeys = {
    all: ['systemSettings'] as const,
    config: (userId: string | undefined, language: string) =>
        [...systemSettingsKeys.all, 'config', userId, language] as const,
    configs: () => [...systemSettingsKeys.all, 'config'] as const,
    uploadLimits: () => [...systemSettingsKeys.all, 'uploadLimits'] as const,
    storageSpace: (tenantId: string | null) =>
        [...systemSettingsKeys.all, 'storageSpace', tenantId] as const,
};
